/* v8 ignore start */
import {JsonModel} from "@/lib/core/jsonModel";

export class RectangleModel extends JsonModel<RectangleModel.IJson> {
  public get x(): number {
    return this.json.x;
  }

  public get y(): number {
    return this.json.y;
  }

  public get width(): number {
    return this.json.width;
  }

  public get height(): number {
    return this.json.height;
  }

  public get area(): number {
    return this.width * this.height;
  }

  public get aspectRatio(): number {
    return this.width / this.height;
  }

  public get isPortrait(): boolean {
    return this.aspectRatio < 1;
  }

  public get isLandscape(): boolean {
    return this.aspectRatio > 1;
  }
}

export namespace RectangleModel {
  export interface IJson {
    x: number;
    y: number;
    width: number;
    height: number;
  }
}
/* v8 ignore stop */
